import { Component, h, Prop } from "@stencil/core";
import { TextFieldProps } from "../f-text-field/f-text-field-model";

@Component({
  tag: "f-text-field-group",
  styleUrl: "f-text-field-group.scss",
  shadow: true,
})
export class TextField {
  @Prop({ mutable: true }) mandatory? = false;
  @Prop() legend: string;
  @Prop({ mutable: true }) disabled: TextFieldProps["disabled"] = false;

  render() {
    return (
      <div
        class={{
          "a-text-field-group": true,
          "a-text-field-group--disabled": this.disabled,
        }}
        data-test="text-field-group"
      >
        {Boolean(this.legend) ? (
          <span
            class="a-text-field-group__legend"
            data-test="text-field-legend"
          >
            {this.legend} {this.mandatory ? "*" : ""}
          </span>
        ) : (
          ""
        )}
        <div class="a-text-field-group__row" data-test="text-field-group-row">
          <slot />
        </div>
      </div>
    );
  }
}
